<template>
  <div>
    <!-- Search筛选 -->
    <el-form :inline="true" :model="params" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="params.trans_id" placeholder="Business Trans Id" clearable style="width:200px">
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-cascader :options="country_business" size="small"
          :props="{ checkStrictly: true,value:'name',label:'name',expandTrigger: 'hover'}" clearable
          placeholder="Country/Business" @change="cascaderChange" style="position:relative;right:2px">
        </el-cascader>
      </el-form-item>
      <el-select size="small" v-model="params.operator_id" clearable placeholder="Country/Operator"
        style="width:160px;position:relative;top: 5px;right:5px">
        <el-option v-for="item in trans_operator" :key="item.id" :label="item.country+' | '+item.name" :value="item.id">
        </el-option>
      </el-select>
      <el-select size="small" v-model="params.rob_user_id" clearable placeholder="Rob user"
        style="width:120px;position:relative;top: 5px;right:5px">
        <el-option v-for="item in sms_user_list" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <el-select size="small" v-model="params.type" clearable placeholder="Type"
        style="width:120px;position:relative;top: 5px;right:5px">
        <el-option v-for="item in type_list" :key="item.k" :label="item.v" :value="item.k">
        </el-option>
      </el-select>
      <el-select size="small" v-model="params.rob_type" clearable placeholder="Grab Type"
        style="width:120px;position:relative;top: 5px;right:5px">
        <el-option v-for="item in rob_type_list" :key="item.k" :label="item.v" :value="item.k">
        </el-option>
      </el-select>
      <el-form-item label="">
        <el-input size="small" v-model="params.rob_user_name" placeholder="Rob user" clearable style="width:140px">
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="params.amount" placeholder="Amount" clearable style="width:100px">
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="params.transaction_id" placeholder="Transaction Id" clearable
          style="width:100px">
        </el-input>
      </el-form-item>
      <el-select size="small" v-model="params.state" clearable placeholder="Status"
        style="width:100px;position:relative;top: 5px;right:5px">
        <el-option v-for="item in state_list" :key="item.k" :label="item.v" :value="item.k">
        </el-option>
      </el-select>
      <el-select size="small" v-model="params.is_top" clearable placeholder="Is top"
        style="width:120px;position:relative;top: 5px;right:5px">
        <el-option v-for="item in is_top_list" :key="item.k" :label="item.v" :value="item.k">
        </el-option>
      </el-select>
      <el-form-item label="">
        <el-input size="small" v-model="params.paid_phone" placeholder="Paid phone" clearable style="width:140px">
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-date-picker v-model="params.success_time" type="daterange" size="small" value-format="yyyy-MM-dd"
          align="right" unlink-panels start-placeholder="Start date(Success)" end-placeholder="End date(Success)"
          :picker-options="pickerOptions" clearable>
        </el-date-picker>
      </el-form-item>
      <el-form-item label="">
        <el-date-picker v-model="params.add_time" type="daterange" size="small" value-format="yyyy-MM-dd" align="right"
          unlink-panels start-placeholder="Start date(Add)" end-placeholder="End date(Add)" :picker-options="pickerOptions"
          clearable>
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">Search</el-button>
        <!-- <el-button type="success" size="small"  icon="el-icon-document" @click="exportExcel">Export</el-button> -->
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" element-loading-text="Loading..."
      style="width: 1512px;">
      <el-table-column prop="t_id" label="Id" width="80" align="center">
      </el-table-column>
      <el-table-column prop="amount" label="Amount" width="70">
      </el-table-column>
      <el-table-column prop="paid_phone" label="User" width="130">
        <template slot-scope="scope">
          <div>{{scope.row.paid_phone}}</div>
          <div>{{scope.row.paid_name}}</div>
          <div v-if="scope.row.operator">
            <el-link type="primary" :underline="false">{{scope.row.operator}}</el-link>
          </div>
          <div v-if="scope.row.paid_bank">
            <el-link type="primary" :underline="false">{{scope.row.paid_bank}}</el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="rob_user_name" label="Grab" width="130">
        <template slot-scope="scope">
          <div v-if="scope.row.rob_user_name">
            <el-link type="warning" icon="el-icon-edit" :underline="false">
              {{scope.row.rob_user_name}}</el-link>
            <div>{{scope.row.reward}}</div>
            <div>
              <el-link type="primary" :underline="false" v-if="scope.row.rob_type==1">Manual</el-link>
              <el-link type="success" :underline="false" v-if="scope.row.rob_type==2">Auto</el-link>
            </div>
          </div>
          <div v-else>
            <el-link type="danger" icon="el-icon-edit" :underline="false">
              distribution</el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="state" align="center" label="Status" width="100">
        <template slot-scope="scope">
          <el-link type="primary" :underline="false" v-if="scope.row.state==1">To be paid</el-link>
          <el-link type="warning" :underline="false" v-if="scope.row.state==2">Confirmed</el-link>
          <el-link type="success" :underline="false" v-if="scope.row.state==3">Completed</el-link>
          <el-link type="danger" :underline="false" v-if="scope.row.state==4">Rejected</el-link>
          <el-link type="danger" :underline="false" v-if="scope.row.state==5">Locked</el-link>
          <el-link type="danger" :underline="false" v-if="scope.row.state==6">Refund</el-link>
          <el-link type="danger" :underline="false" v-if="scope.row.state==7">Exceptional</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="add_time" label="Time【1】" width="200">
        <template slot-scope="scope">
          <div><span style="color:#909399">Add：</span>{{scope.row.add_time|timestampToTime}}</div>
          <div><span style="color:#909399">Lock：</span>{{scope.row.rob_time|timestampToTime}}</div>
          <div><span style="color:#909399">Handle：</span>{{scope.row.pay_time|timeCal}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="add_time" label="Time【2】" width="210">
        <template slot-scope="scope">
          <div><span style="color:#909399">Call：</span>{{scope.row.call_time|timestampToTime}}</div>
          <div><span style="color:#909399">Confirm：</span>{{scope.row.confirm_time|timestampToTime}}</div>
          <div><span style="color:#909399">Success：</span>{{scope.row.success_time|timestampToTime}}</div>
          <div v-if="scope.row.rejected_time"><span
              style="color:#909399">Rejected：</span>{{scope.row.rejected_time|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="business_name" label="Business" width="90">
      </el-table-column>
      <el-table-column prop="trans_id" label="Trans id" width="100">
      </el-table-column>
      <el-table-column prop="country" label="Country" width="80">
      </el-table-column>
      <el-table-column prop="transaction_id" label="Transaction Id" width="120">
      </el-table-column>
      <el-table-column prop="rejected_back_state" label="Reject callback" width="100">
        <template slot-scope="scope" v-if="scope.row.rejected_time">
          <el-link type="danger" :underline="false" v-if="scope.row.rejected_back_state==0">fail</el-link>
          <el-link type="primary" :underline="false" v-if="scope.row.rejected_back_state==1">success</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="type" align="center" label="Type/Top" width="100">
        <template slot-scope="scope">
          <div>
            <el-link type="success" :underline="false" v-if="scope.row.type==0">normal</el-link>
            <el-link type="primary" :underline="false" v-if="scope.row.type==1">kaka</el-link>
            <el-link type="warning" :underline="false" v-if="scope.row.type==2">withdrawal</el-link>
            <el-link type="danger" :underline="false" icon="el-icon-edit" v-if="scope.row.type==3&&scope.row.state==1">
              same
            </el-link>
            <el-link type="danger" :underline="false" v-if="scope.row.type==3&&scope.row.state!=1">same</el-link>
          </div>
          <div>
            <el-link type="warning" icon="el-icon-edit" :underline="false" v-if="scope.row.is_top">Yes</el-link>
            <el-link type="info" icon="el-icon-edit" :underline="false" v-else>No
            </el-link>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
  </div>
</template>

<script>
  import {
    transactionBackupsList,
    transRejected,
    transactionTop,
    getSmsUserList,
    transactionUnlock,
    transactionSucc,
    assignRobber,
    rejectedCallback,
    transactionSmsUser,
    getCountryBusiness,
    transOperator
  } from '../../api/apiFun'
  import {
    timestampToTime,
    exportUrl,
    cascaderChange,
  } from '@/utils/util';
  import Pagination from '../../components/Pagination'
  let that = ""
  export default {
    data() {
      return {
        title: '',
        loading: false, //是显示加载
        examineVisible: false, //控制Edit页面显示与隐藏
        params: {
          page: 1,
          limit: 10,
          trans_id: '',
          transaction_id: '',
          paid_phone: '',
          state: '',
          success_time: '',
          add_time: '',
          business_name: '',
          rob_user_id: '',
          amount: '',
          type: '',
          is_top: '',
          rob_user_name: '',
          country: '',
          rob_type: '',
          operator_id: ''
        },
        robber_params: {
          name: '',
          country: '',
          business_name: '',
        },
        state_list: [{
            k: 1,
            v: 'To be paid'
          },
          {
            k: 2,
            v: 'Confirmed'
          },
          {
            k: 3,
            v: 'Completed'
          },
          {
            k: 4,
            v: 'Rejected'
          },
          {
            k: 5,
            v: 'Locked'
          },
          {
            k: 6,
            v: 'Refund'
          },
          {
            k: 7,
            v: 'Exceptional'
          },
        ],
        type_list: [{
            k: 0,
            v: 'normal'
          },
          {
            k: 1,
            v: 'kaka'
          },
          {
            k: 2,
            v: 'withdrawal'
          },
          {
            k: 3,
            v: 'same'
          },
        ],
        rob_type_list: [{
            k: 1,
            v: 'Manual'
          },
          {
            k: 2,
            v: 'Auto'
          },
        ],
        is_top_list: [{
            k: 0,
            v: 'No'
          },
          {
            k: 1,
            v: 'Yes'
          },
        ],
        business_list: [],
        sms_user_list: [],
        sms_user_list_new: [],

        listData: [], //User数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        pickerOptions: {
          shortcuts: [{
            text: 'Today',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last week',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last month',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        detailVisible: false,
        detail_info: {},
        transaction_id: '',
        examineInfo: {},
        rules: {
          business_id: [{
            required: true,
            message: 'Please select business',
            trigger: 'blur'
          }],
          amount: [{
            required: true,
            message: 'Amount',
            trigger: 'blur'
          }],
          phone: [{
            required: true,
            message: 'Please enter phone number',
            trigger: 'blur'
          }],
          name: [{
            required: true,
            message: 'Please enter name',
            trigger: 'blur'
          }],
        },
        assign_robber: {
          id: 0,
          rob_user_id: 0,
        },
        assignVisible: false,
        callbackVisible: false,
        rejectedInfo: {},
        country_business: [],
        trans_operator: []
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    filters: {
      timestampToTime: function (timestamp) {
        return timestampToTime(timestamp)
      },
      transactionBackupsListstate: function (i) {
        var v = '';
        that.state_list.forEach(e => {
          if (e.k == i) {
            v = e.v
          }
        });
        return v
      },
      timeCal: function (runTime) {
        let day = Math.floor(runTime / 86400);
        runTime = runTime % 86400;
        let hour = Math.floor(runTime / 3600);
        runTime = runTime % 3600;
        let minute = Math.floor(runTime / 60);
        runTime = runTime % 60;
        let second = runTime;
        let str = '';
        if (day > 0) {
          str += day + ' Days ';
        }
        if (hour > 0) {
          str += hour + ' Hours ';
        }
        if (minute > 0) {
          str += minute + ' Minutes ';
        }
        if (second > 0) {
          str += second + ' Seconds ';
        }
        return str;
      }
    },
    created() {
      that = this
      this.getdata(this.params)
      this.getSmsUserList()
      this.getCountryBusiness()
      this.transOperator()
    },
    methods: {
      transOperator() {
        transOperator().then(res => {
          if (res.code == 400) {
            this.$message({
              state: 'info',
              message: res.msg
            })
          } else {
            this.trans_operator = res.datas;
          }
        }).catch(err => {
          this.$message.error('Failed to obtain trans_operator list, please try again later!')
        })
      },
      getCountryBusiness() {
        getCountryBusiness().then(res => {
          if (res.code == 400) {
            this.$message({
              state: 'info',
              message: res.msg
            })
          } else {
            this.country_business = res.datas;
          }
        }).catch(err => {
          this.$message.error('Failed to obtain business list, please try again later!')
        })
      },
      cascaderChange(value) {
        var cascader = cascaderChange(value)
        this.robber_params.country = this.params.country = cascader[0]
        this.robber_params.business_name = this.params.business_name = cascader[1]
        this.getSmsUserList()
      },
      assignRobber(id) {
        this.assign_robber.id = id;
        this.transactionUserList({
          id: id
        });
        this.assignVisible = true
      },
      transactionUserList(params) {
        transactionSmsUser(params).then(res => {
          if (res.code == 400) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.sms_user_list_new = res.datas.list
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('Failed to get SIM card list, please try again later!')
        })
      },
      transactionSucc(id) {
        if (!this.transaction_id) {
          this.$message.error('Please enter Transaction Id')
          return
        }
        this.loading = true
        transactionSucc({
          id: id,
          transaction_id: this.transaction_id
        }).then(res => {
          this.loading = false
          this.detailVisible = false
          if (res.code == 200) {
            this.getdata(this.params)
            this.$message({
              type: 'success',
              message: 'Successful withdrawal！'
            })
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        }).catch(err => {
          this.detailVisible = false
          this.loading = false
          this.$message.error('Failed, please try again later!')
        })
      },
      rejectedCallback(row) {
        this.rejectedInfo = row
        this.callbackVisible = true
      },
      callbackSubmit() {
        this.loading = true
        rejectedCallback({
          id: this.rejectedInfo.id,
        }).then(res => {
          this.loading = false
          if (res.code == 400) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.callbackVisible = false
            this.getdata(this.params)
            this.$message({
              type: 'success',
              message: 'Send callback successfully'
            })
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('Failed to send callback, please try again later!')
        })
      },
      robberSearch() {
        this.getSmsUserList()
      },
      submitRobber() {
        console.log(this.assign_robber)
        if (!this.assign_robber.rob_user_id) {
          this.$message.error('Please choose single person')
          return
        }
        this.loading = true
        assignRobber(this.assign_robber).then(res => {
          this.loading = false
          this.assignVisible = false
          if (res.code == 200) {
            this.getdata(this.params)
            this.$message({
              type: 'success',
              message: 'success'
            })
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        }).catch(err => {
          this.assignVisible = false
          this.loading = false
          this.$message.error('Failed, please try again later!')
        })
      },
      unlock(id) {
        this.$confirm('Are you sure you want to cancel the order grabber?', 'Tips', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          transactionUnlock({
            id,
          }).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '解除Grab人success！'
              })
              this.getdata(this.params)
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          }).catch(err => {
            this.$message.error('Failed, please try again later!')
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Cancelled解除Grab人'
          })
        })
      },
      setTop(id, is_top) {
        var t = is_top == 1 ? 'Are you sure you want to stick to the top?' : 'Are you sure you want to unpin？';
        this.$confirm(t, 'Tips', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          transactionTop({
            id,
            is_top
          }).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: 'Set upsuccess！'
              })
              this.getdata(this.params)
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          }).catch(err => {
            this.$message.error('Failed, please try again later!')
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'CancelledSet up'
          })
        })
      },
      seeDetail(detail_info) {
        if (detail_info.state == 3 || detail_info.state == 4) {
          this.$message.error('Cannot perform the operation！')
          return
        }
        this.detailVisible = true
        this.detail_info = detail_info
      },
      transRejected(row) {
        if (row.state == 3 || row.state == 4) {
          this.$message.error('Cannot perform the operation！')
          return
        }
        this.$confirm('Are you sure you want to reject?', 'Tips', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          this.loading = true
          transRejected({
            id: row.id
          }).then(res => {
            this.loading = false
            this.getdata(this.params)
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: 'success'
              })
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          }).catch(err => {
            this.loading = false
            this.$message.error('Failed, please try again later!')
          })

        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Cancelled reject'
          });
        });
      },
      exportExcel() {
        window.location.href = exportUrl('/admin/transaction/export_transaction', this.params);
      },
      closeDialog(type) {
        if (type == 'detail') {
          this.detailVisible = false
        }
        if (type == 'rejected') {
          this.rejectedVisible = false
        }
        if (type == 'callback') {
          this.callbackVisible = false
        }
      },
      getSmsUserList() {
        getSmsUserList(this.robber_params).then(res => {
          if (res.code == 400) {
            this.$message({
              state: 'info',
              message: res.msg
            })
          } else {
            this.sms_user_list = res.datas.list
          }
        }).catch(err => {
          this.$message.error('Failed to get app user, please try again later!')
        })
      },
      // 获取Withdraw
      getdata(parameter) {
        if (parameter.success_time == null) {
          parameter.success_time = ''
        }
        this.loading = true
        transactionBackupsList(parameter).then(res => {
          this.loading = false
          if (res.code == 400) {
            this.$message({
              state: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.datas.list
            // 分页赋值
            this.pageparm.currentPage = this.params.page
            this.pageparm.pageSize = this.params.limit
            this.pageparm.total = res.datas.count
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('Failed to get the withdraw list, please try again later!')
        })
      },
      // 分页插件事件
      callFather(parm) {
        this.params.page = parm.currentPage
        this.params.limit = parm.pageSize
        this.getdata(this.params)
      },
      // Search事件
      search() {
        this.params.page = 1
        this.getdata(this.params)
      },
    }
  }

</script>

<style scoped>
  .el-image__error {
    font-size: 12px !important;
  }

  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/views/transaction/transaction_backups.vue